// extracted by mini-css-extract-plugin
export default {"attendance-overview-content__section":"styles_attendance-overview-content__section__6RARo"};